import React, { Component } from 'react';
import { Modal, Table,Button } from 'react-bootstrap';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import FlatButton from 'material-ui/FlatButton';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';

var Config = require('../../../config');

class ModalInfo extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.donor_checked = this.donor_checked.bind(this);

		this.state = {
		    show: false,
		    date:"",
			hour:"",
			site:"",
			health_facilities:[],
			load_site:false,
			observations:"",
			amount:"",
			unit:"",
			units:[],
			indice:-1,
			requestSelected:[],
			width:"",
			process:'register',
			unit_removed:false,
			reasons:[],
			ids:[],
			listadounit:[],
			listadoenable:true
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ 
			show: false, 
			date:"",
			hour:"",
			site:"",
			health_facilities:[],
			load_site:false,
			observations:"",
			amount:"",
			unit:"",
			units:[],
			indice:-1,
			requestSelected:[],
			width:"",
			process:'register',
			unit_removed:false,
			reasons:[],
			ids:[],
		});
	}

	handleShow(id) {
		

		fetch(Config.default.apiGateway.URL+'national_centers/exclude_hemored?health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			var temp = [];
			for (var i = 0; i < response.length; i++) {
				response[i].name = response[i].national_center.name +' - '+
													response[i].address.estado !== null	?
														response[i].address.estado
													: "";
				temp.push(response[i].national_center)
			};

			this.setState({national_centers: temp});

			
			this.props.waiting.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'plasma_process/'+id,{
				method: 'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
				console.log(response);
					var index = this.state.national_centers.findIndex(obj =>
						obj.id === response.plasma_process.national_centers_id
					);

					this.setState({
						date:moment(response.plasma_process.date).format('YYYY-MM-DD'),
						hour:moment(response.plasma_process.hour, 'HH:mm:ss').format('HH:mm'),
						site:response.plasma_process.national_centers_id,
						observations: response.plasma_process.observations,
						amount:response.plasma_parts.length,
						process:'update',
						indice:0,
						requestSelected:[this.state.national_centers[index]],
						units:response.plasma_parts,
						show: true
					});

				}
			})
			
		});
		
	}
	donor_checked(e, b) {
		if (e.target.checked){
		  // Si no existe, agregarlo
		  this.state.listadounit.push(b);
		  this.setState({listadoenable:false});
		}else {
		  // Si ya existe, quitarlo
		  const helper =this.state.listadounit.filter(y=>y.unit_id!=b.unit_id);
		  this.setState({listadounit:helper});
		  if (helper.length==0) {
			  this.setState({listadoenable:true})
		  }
		}
	}
	deleteUnits(e,list){
		e.preventDefault();
console.log(list);
fetch(Config.default.apiGateway.URL+'plasma_process/unit_list',{
	method: 'POST',
	body: JSON.stringify(list),
	headers: new Headers({
		'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
		'Accept'		: 'application/json',
		'Content-Type'	: 'application/json'
	})
}).then(res => {
	this.props.waiting.handleClose();
	if(res.ok){
		return res.json();
	}else{
		res.text().then((msg)=>{
			swal('Error', msg, 'error');
		});
	}
}).then(response => {
	if(response !== undefined){
		console.log(response);
		swal('Correcto', 'Proceso terminado', 'success');
	}
});
	}
	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal bsSize={"lg"} show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalle Plasma Industrializar</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Fecha Envío</span>
								<input type="date" name="date" id="date" value={this.state.date} disabled
									onChange={(e)=>e.preventDefault()} className="form-control hour-input" />
							</div>
							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Hora Envío</span>
								<input name="hour" id="hour" type="text"
									data-inputmask-alias="datetime"  data-inputmask-inputformat="HH:MM"  
									data-inputmask-placeholder="-" className="form-control" disabled
									value={this.state.hour || ""}  onChange={(e)=>e.preventDefault()} />
							</div>
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Sitio Envío</span>
								<AsyncTypeahead
						          	labelKey={(option) => `${option.name}`}
						          	minLength={0}
						          	inputProps={{
						          		name:"site",
						          		required: true,
						          		id:"site",
						          	}}
						          	disabled
						          	id="AutSite"
						          	options={this.state.national_centers}
						          	onChange={(e)=>e.preventDefault()}
						            onSearch={(e)=>e.preventDefault()}
						          	defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
						          	selected={this.state.requestSelected}
						          	ref={ref => this._typeahead = ref}
						          	useCache={false}
						          	isLoading={this.state.load_site}
						          	delay={700}
						          	paginationText="Mostrar mas resultados..."
						        />
							</div>
						</div>

						<div className="col-xs-12">
							<div className="col-xs-8 col-sm-9">
								<span className="span-min">Observaciones</span>
								<textarea name="observations" id="observations" value={this.state.observations}
									onChange={(e)=>e.preventDefault()} className="form-control" disabled
									style={{height:"80px",width:"100%",resize:"none"}}>
								</textarea>
							</div>
						</div>
						<hr style={{width:'90%'}} />
						
						<div className="col-xs-12">
						<Button className="btn btn-info ml-3" onClick={(e)=>this.deleteUnits(e,this.state.listadounit)} disabled={this.state.listadoenable} style={{float:"right"}}>
                                       Eliminar
								</Button>
							<table className="table mt-5" id="tbl_list">
								<thead>
									<tr>
										<th> </th>
										<th>Unidad</th>
										<th>Componente</th>
										<th>No. Componente</th>
										<th>Volumen</th>
									</tr>
								</thead>
								<tbody>
									{this.state.units.map((unit, j)=>(
										<tr key={j}>
											<td><input type="checkbox"  onChange={(e)=>this.donor_checked(e,unit)}/></td>
											<td>{unit.unit_number}</td>
											<td>{unit.component}</td>
											<td>{unit.component_number}</td>
											<td>{unit.volume}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={'Cerrar'} onClick={this.handleClose} />
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalInfo);